// extracted by mini-css-extract-plugin
export default {"box":"iOXKV_b7Nhq8zhZjTEZf","title":"fuUcA_xiHvBMFsAgZizG","description":"_2cSGdptD_UhVnu4pohg","note":"HtxEkyWLXw2NCfyIrPsg"};